import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../../styles/contact.css';
import { useSelector } from 'react-redux';
import { PageHeading, PageLine } from '../../componetns';
import { FaLinkedinIn, FaTwitter, FaInstagram, FaFacebookF, FaGithub } from "react-icons/fa";
import Swal from 'sweetalert2';
const Contact = () => {
    const form = useRef();
    const { isDark } = useSelector((state) => state.useReducer);
    const [Name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [Message, setMessage] = useState("")
    const sendContactData = (event) => {
        event.preventDefault();
        if (Name === "") {
            const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                background: '#3F51B5',
                color: "#fff",
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "Enter FullName"
            });
        } else if (email === "") {
            const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                background: '#3F51B5',
                color: "#fff",
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "Enter Email "
            });
        } else if (Message === "") {
            const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                background: '#3F51B5',
                color: "#fff",
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: " Enter Your Message"
            });
        }
        else {
            const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                background: '#3F51B5',
                color: "#fff",
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "success",
                title: "email sent, Thankyou!"
            });
            setName("")
            setEmail("")
            setMessage("")
            emailjs.sendForm('service_i5w3hz6', 'template_fg3dkm3', form.current, 'XULp0acZDQ-YQMmay')
                .then((result) => {
                    setName("")
                    setEmail("")
                    setMessage("")
                }, (error) => {
                    console.log(error.text);
                });
        }
    }
    return (
        <div className='contact-main' style={{ backgroundColor: `${isDark ? "#070F2B" : "#fff"}` }} name="contact">
            <PageLine />
            <PageHeading heading="Contact Me" />
            <div className='container' >
                <div className='row' style={{padding:"15px "}}>
                    <div className='col-12 col-md-6 contact-form'>
                        <form onSubmit={sendContactData} ref={form}>
                            <label htmlFor="name" >Name</label>
                            <input type="text" name="user_name" id='name' placeholder='Your Name' value={Name} onChange={(e) => setName(e.target.value)}  style={{ color: `${isDark ? "#fff" : "#000"}` }}/>
                            <label htmlFor="email">Email</label>
                            <input type="email" name="user_email" id='email' placeholder='Your Email' value={email} onChange={(e) => setEmail(e.target.value)}  style={{ color: `${isDark ? "#fff" : "#000"}` }}/>
                            <label htmlFor="message">Message</label>
                            <textarea name="message" type="text" id='message' placeholder='Message' value={Message} onChange={(e) => setMessage(e.target.value)}  style={{ color: `${isDark ? "#fff" : "#000"}` }}/>
                            <input type="submit" value="Send" id='email-sent-btn' />
                        </form>
                    </div>
                    <div className='col-12 col-md-6 contact-details'>
                        <div className='contact-data'>
                            <h1>Gmail</h1>
                            <a href='mailto:munesh788mk@gmail.com' target='_blank' rel="noreferrer" style={{ color: `${isDark ? "#fff" : "#000"}` }}>munesh788mk@gmail.com</a>
                            <h1>Phone Number</h1>
                            <a href="tel:+923463037523" target='_blank' rel="noreferrer" style={{ color: `${isDark ? "#fff" : "#000"}` }}>+923463037523</a>
                            <h1>location</h1>
                            <a style={{ color: `${isDark ? "#fff" : "#000"}` }} href='https://www.google.com/maps/place/Hyderabad, Sindh' target='_blank'  rel="noreferrer" >Hyderabad, Sindh</a>
                        </div>
                        <div className='social-plat-div'>
                            <FaGithub className='social-icon' style={{ color: "#070F2B", backgroundColor: "#3F51B5" }} onClick={() => window.open('https://github.com/Muneshkumar12/', "_blank")} />
                            <FaLinkedinIn className='social-icon' style={{ color: "#070F2B", backgroundColor: "#3F51B5" }} onClick={() => window.open("https://www.linkedin.com/in/munesh-kumar-1b8860289/", "_blank")} />
                            <FaTwitter className='social-icon' style={{ color: "#070F2B", backgroundColor: "#3F51B5" }} />
                            <FaInstagram className='social-icon' style={{ color: "#070F2B", backgroundColor: "#3F51B5" }} onClick={() => window.open("https://www.instagram.com/munesh_kumar3/", "_blank")} />
                            <FaFacebookF className='social-icon' style={{ color: "#070F2B", backgroundColor: "#3F51B5" }} onClick={() => window.open("https://www.facebook.com/profile.php?id=100069228849518", "_blank")} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
